import { render } from "./rootpanel.vue?vue&type=template&id=92eb52d8&scoped=true"
import script from "./rootpanel.vue?vue&type=script&lang=js"
export * from "./rootpanel.vue?vue&type=script&lang=js"

import "./rootpanel.vue?vue&type=style&index=0&id=92eb52d8&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92eb52d8"]])

export default __exports__